import {
    HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AppconfigService } from '@core/services/utility/appconfig.service';
import { NewRelicService } from '@core/services/utility/new-relic.service';
import { environment } from '@environments/environment';

export const httpRequestInterceptor: HttpInterceptorFn = (request, next) => {
  const appConfigService = inject(AppconfigService);
  const newRelicService = inject(NewRelicService);

  let authReq = request;
  const sessionId = newRelicService.getSessionId();

  if (
    appConfigService.appsettings &&
    appConfigService.appsettings.authentcationMethod?.toLowerCase() === 'windows' &&
    request.url &&
    request.url.includes(environment.commonBaseUrl)
  ) {
    authReq = request.clone({
      withCredentials: true,
      headers: request.headers.set('X-Session-ID', sessionId),
    });
  } else {
    authReq = request.clone({
      headers: request.headers
        .set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
        .set('X-Session-ID', sessionId)
    });
  }

  return next(authReq);
};

